import {
  backend_url,
  uninterceptedAxiosInstance,
} from "../common/commonVariables";

import { Country, State } from "country-state-city";
export const createNewCustomer = async (
  name,
  phone,
  website,
  email,
  serviceType,
  description,
  billingInformation,
  logo,
  organisation = "",
  createdByUser = null,
  locations = null,
  Industry = null,
  contactInformation
) => {
  try {
    let params = {
      name: name,
      phone: phone,
      website: website,
      email: email,
      serviceType: serviceType,
      description: description,
      billingInformation: billingInformation,
      organisation,
      createdByUser,
      locations,
      Industry,
      contactInformation,
      logo,
    };

    if (params?.billingInformation?.country) {
      params.billingInformation.countryName = Country.getCountryByCode(
        params?.billingInformation?.country
      )?.name;
    }
    if (params?.billingInformation?.city) {
      const citiesOfCountry = State.getStatesOfCountry(
        params.billingInformation.country
      );
      const the_city = params.billingInformation.city
        ? citiesOfCountry.filter((city) => {
            return city.isoCode == params.billingInformation.city;
          })[0].name
        : "";
      params.billingInformation.cityName = the_city;
    }

    const response = await uninterceptedAxiosInstance.post(
      backend_url + "customers",
      { data: params },
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err.response.status,
      error: err.response?.data?.error,
    };
  }
};

export const deleteCustomer = async (ID, reason) => {
  try {
    let params = {
      data: [
        {
          id: ID,
          deleteReason: reason,
        },
      ],
    };
    const response = await uninterceptedAxiosInstance.post(
      backend_url + "customers/removeCustomers",
      params,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err.response.status,
      error: err.response?.data?.error,
    };
  }
};

export const updateCustomer = async (
  id,
  name,
  phone,
  website,
  email,
  serviceType,
  description,
  billingInformation,
  logo,
  locations = null,
  Industry = null,
  contactInformation,
  organisation
) => {
  try {
    let params = {
      name,
      phone,
      website,
      email,
      serviceType,
      description,
      billingInformation,
      locations,
      Industry,
      logo,
      contactInformation,
      organisation,
    };

    if (params?.billingInformation?.country) {
      params.billingInformation.countryName = Country.getCountryByCode(
        params?.billingInformation?.country
      )?.name;
    }
    if (params?.billingInformation?.city) {
      const citiesOfCountry = State.getStatesOfCountry(
        params.billingInformation.country
      );
      const the_city = params.billingInformation.city
        ? citiesOfCountry.filter((city) => {
            return city.isoCode == params.billingInformation.city;
          })[0].name
        : "";
      params.billingInformation.cityName = the_city;
    }

    const response = await uninterceptedAxiosInstance.put(
      backend_url + "customers/" + id,
      { data: params },
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;
    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err.response.status,
      error: err.response?.data?.error,
    };
  }
};
